function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 545",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(0 .001)",
    style: {
      fill: "#3c5a9a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3421",
    d: "M335.324 92.677h-3.546c-2.1 0-4.444.885-4.444 3.935.01 1.063 0 2.081 0 3.226H324.9v3.874h2.509v11.151h4.611v-11.225h3.044l.275-3.811h-3.4s.008-1.7 0-2.187c0-1.205 1.254-1.136 1.33-1.136h2.055v-3.827z",
    transform: "translate(-314.04 -87.69)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b3e356e674f331b89eebd348e8e98031.svg";
export { ForwardRef as ReactComponent };